module.exports = __webpack_public_path__ + "img/1-3.e40dc2e0.jpg";